export default __webpack_public_path__ + "static/media/a1.4a4e35be.png";